import { useEffect, useState } from "react";
import API from "../services/api";

import {
  Box,
  Typography,
  Grid,
  Paper,
  Button
} from "@mui/material";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";

import ParticleBackground from "../components/common/ParticleBackground";

export default function AdminDashboard() {

  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("all");

  // =========================
  // 📡 FETCH ORDERS
  // =========================
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await API.get("/admin/orders", {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        setOrders(res.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchOrders();
  }, []);

  // =========================
  // 💰 MÉTRICAS
  // =========================
  const totalRevenue = orders.reduce((acc, o) => {
    if (o.status === "approved") {
      return acc + o.total;
    }
    return acc;
  }, 0);

  const totalOrders = orders.length;

  const approvedOrders = orders.filter(
    o => o.status === "approved"
  ).length;

  // =========================
  // 📊 DATA PARA GRÁFICO
  // =========================
  const salesByDay = {};

  orders.forEach(order => {
    const date = new Date(order.createdAt).toLocaleDateString();

    if (!salesByDay[date]) {
      salesByDay[date] = 0;
    }

    if (order.status === "approved") {
      salesByDay[date] += order.total;
    }
  });

  const chartData = Object.keys(salesByDay).map(date => ({
    date,
    total: salesByDay[date]
  }));

  // =========================
  // 🔍 FILTROS
  // =========================
  const filteredOrders = orders.filter(order => {
    if (filter === "approved") return order.status === "approved";
    if (filter === "pending") return order.status === "pending";
    return true;
  });

  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: 4,
        background: `
          radial-gradient(circle at 50% 0%, rgba(255,110,0,0.15), transparent 40%),
          linear-gradient(180deg, #141414 0%, #2a1208 100%)
        `
      }}
    >
      <ParticleBackground />

      <Typography variant="h4" sx={{ color: "#fff", mb: 4 }}>
        📊 Panel de Ventas
      </Typography>

      {/* =========================
          📦 MÉTRICAS
      ========================= */}
      <Grid container spacing={3}>

        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3 }}>
            <Typography>Total Ventas</Typography>
            <Typography variant="h5">
              ${totalRevenue}
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3 }}>
            <Typography>Órdenes</Typography>
            <Typography variant="h5">
              {totalOrders}
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 3 }}>
            <Typography>Aprobadas</Typography>
            <Typography variant="h5">
              {approvedOrders}
            </Typography>
          </Paper>
        </Grid>

      </Grid>

      {/* =========================
          📈 GRÁFICO
      ========================= */}
      <Box sx={{ mt: 6 }}>
        <Typography variant="h5" sx={{ color: "#fff", mb: 2 }}>
          Ventas por día
        </Typography>

        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <XAxis dataKey="date" stroke="#fff" />
            <YAxis stroke="#fff" />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="total"
              stroke="#ff6e00"
              strokeWidth={3}
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>

      {/* =========================
          🔍 FILTROS
      ========================= */}
      <Box sx={{ mt: 4, mb: 2, display: "flex", gap: 2 }}>
        <Button variant="contained" onClick={() => setFilter("all")}>
          Todas
        </Button>

        <Button variant="contained" onClick={() => setFilter("approved")}>
          Aprobadas
        </Button>

        <Button variant="contained" onClick={() => setFilter("pending")}>
          Pendientes
        </Button>
      </Box>

      {/* =========================
          📋 LISTA
      ========================= */}
      <Box sx={{ mt: 2 }}>
        {filteredOrders.map(order => (
          <Paper key={order._id} sx={{ p: 2, mb: 2 }}>
            <Typography>
              💳 {order.paymentId}
            </Typography>

            <Typography>
              Estado: {order.status}
            </Typography>

            <Typography>
              Total: ${order.total}
            </Typography>
          </Paper>
        ))}
      </Box>

    </Box>
  );
}